// extracted by mini-css-extract-plugin
export default {"root":"LoadingPage_root__HTrwM"};